import React from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import Portal from 'src/layout/Portal/Portal';
import useEventListener from 'src/hooks/useEventListener';
import { TModalFullScreen, TModalSize } from 'src/type/modal-type';
import Button, { IButtonProps } from 'src/components/bootstrap/Button';
import FormGroup from 'src/components/bootstrap/forms/FormGroup';
import Input from 'src/components/bootstrap/forms/Input';
import Select from 'src/components/bootstrap/forms/Select';
import Option from 'src/components/bootstrap/Option';
import { BsXCircleFill } from 'react-icons/bs';
import QRCode from 'react-qr-code';
import Countdown from 'react-countdown';
import moment from 'moment';

export default function MoDalQrcode({
	isOpen,
	exit,
	typeQrcode,
	urlQrcode,
	qrstring,
	expirationDate,
	closeQr,
	t,
}) {
	const renderer = ({ formatted: { days, hours, minutes, seconds }, completed }) => {
		if (completed) {
			return <span style={{ color: 'red', fontWeight: 'bold' }}>{t('txt_out_of_time')}</span>;
		} else {
			return (
				<>
					{days === '00' ? (
						<span style={{ color: 'green', fontWeight: 'bold' }}>
							{minutes}:{seconds}
						</span>
					) : days !== '00' && !isNaN(days) ? (
						<span style={{ color: 'green', fontWeight: 'bold' }}>
							{minutes}:{seconds}
						</span>
					) : isNaN(seconds) ? (
						<span>{t('txt_out_of_time')}</span>
					) : (
						''
					)}
				</>
			);
		}
	};
	return (
		<div>
			<Portal>
				<AnimatePresence mode='wait'>
					{isOpen && (
						<>
							<motion.div
								initial={{ scale: 0 }}
								animate={{ rotate: 0, scale: 1 }}
								transition={{
									type: 'spring',
									stiffness: 260,
									damping: 20,
								}}
								key='modal'
								className='modal show'
								style={{ display: 'block' }}
								tabIndex={-1}
								aria-hidden='true'>
								<div
									className='modal-dialog
										modal-dialog-scrollable
										modal-dialog-centered'>
									<div className='modal-content'>
										<div className='div_edit_bar'>
											<div className='fw-bold h5'></div>
											<div className='div_exit' onClick={() => exit()}>
												<BsXCircleFill
													style={{ width: '15px', height: 'auto' }}
												/>
											</div>
										</div>
										{typeQrcode === 'web' ? (
											<div className='xxx'>
												<iframe
													className='iframe_gen_qrcode'
													src={urlQrcode}
													title='description'
												/>
											</div>
										) : typeQrcode === 'base64' ? (
											<img className='iframe_gen_qrcode' src={qrstring} />
										) : (
											<div className='div_qrstring'>
												<div>
													{qrstring && (
														<QRCode
															value={qrstring}
															style={{ marginTop: '1rem' }}
														/>
													)}
												</div>

												<div
													style={{
														marginTop: '14px',
														marginBottom: '2rem',
														fontSize: '20px',
													}}>
													{expirationDate && (
														<Countdown
															date={moment(
																expirationDate,
																'YYYY-MM-DD HH:mm:ss',
															).toDate()}
															renderer={renderer}
															onComplete={() =>
																setTimeout(() => {
																	closeQr();
																}, 1000)
															}
														/>
													)}
												</div>
											</div>
										)}
									</div>
								</div>
							</motion.div>
							<div className='modal-backdrop show'></div>
						</>
					)}
				</AnimatePresence>
			</Portal>
		</div>
	);
}
